module.exports = __webpack_public_path__ + "static/Young-Adults-Guide__Worksheets-7220c3568546e07fa34b9e38ad4423ef.pdf";